"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));
var _useLabel2 = _interopRequireDefault(require("../../hooks/useLabel"));
var _InputNumber = _interopRequireDefault(require("../Input/InputNumber"));
var _InputCurrency = _interopRequireDefault(require("../Input/InputCurrency"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } // import useFormElementValidation from '../../hooks/useFormElementValidation';
/**
 * The Input component allows an user to enter data into the application.
 */
var RangeSlider = function RangeSlider(props) {
  var controlledId = props.id,
    initialLabel = props.label,
    helper = props.helper,
    min = props.min,
    max = props.max,
    displayTooltip = props.displayTooltip,
    value = props.value,
    step = props.step,
    onChange = props.onChange,
    double = props.double,
    locale = props.locale,
    displaySuffix = props.displaySuffix,
    displayCurrency = props.displayCurrency,
    leftEdge = props.leftEdge,
    leftCustomEdge = props.leftCustomEdge,
    rightEdge = props.rightEdge,
    rightCustomEdge = props.rightCustomEdge,
    readOnly = props.readOnly,
    disabled = props.disabled,
    className = props.className;
  var id = _react.default.useRef((0, _useRandomId.default)(controlledId)).current;
  var _React$useState = _react.default.useState(double ? 0 : value ? value.min : min),
    minValue = _React$useState[0],
    setMinValue = _React$useState[1];
  var _React$useState2 = _react.default.useState(value ? value.max : max),
    maxValue = _React$useState2[0],
    setMaxValue = _React$useState2[1];
  _react.default.useEffect(function () {
    if (value) {
      setMinValue(value.min);
      setMaxValue(value.max);
    }
  }, [value]);

  // const [errors] = useFormElementValidation(value, {
  //     required,
  // });
  var _useLabel = (0, _useLabel2.default)(initialLabel, _extends({}, props, {
      id: id,
      value: value
    })),
    label = _useLabel.label;
  var handleMinChange = function handleMinChange(e) {
    e.preventDefault();
    var newMinVal = Math.min(+e.target.value, maxValue - step);
    setMinValue(newMinVal);
    if (typeof onChange === 'function') {
      onChange({
        min: newMinVal,
        max: maxValue
      });
    }
  };
  var handleMaxChange = function handleMaxChange(e) {
    e.preventDefault();
    var newMaxVal = double ? Math.max(+e.target.value, minValue + step) : e.target.value;
    setMaxValue(newMaxVal);
    if (typeof onChange === 'function') {
      onChange({
        min: minValue,
        max: newMaxVal
      });
    }
  };
  var setCurrency = function setCurrency(data) {
    return /*#__PURE__*/_react.default.createElement(_InputCurrency.default, {
      value: Number(data),
      locale: locale,
      displayAsText: true
    });
  };
  var setSuffix = function setSuffix(data) {
    return /*#__PURE__*/_react.default.createElement(_InputNumber.default, {
      displayAsText: true,
      value: Number(data),
      suffix: displaySuffix,
      locale: locale,
      readOnly: true
    });
  };
  var formatNumber = function formatNumber(data) {
    return /*#__PURE__*/_react.default.createElement(_InputNumber.default, {
      displayAsText: true,
      value: Number(data),
      locale: locale,
      readOnly: true
    });
  };
  var displayValue = function displayValue(val) {
    return displayCurrency ? setCurrency(val) : displaySuffix ? setSuffix(val) : formatNumber(val);
  };
  var minPos = (minValue - min) / (max - min) * 100;
  var maxPos = (maxValue - min) / (max - min) * 100;
  var containerClasses = (0, _clsx.default)('uk-form-item', 'uk-range-slider', disabled && 'disabled', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClasses
  }, label, /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__container"
  }, leftCustomEdge && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__edge-value uk-range-slider__left-value"
  }, leftCustomEdge), leftEdge !== 'hide' && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__edge-value uk-range-slider__left-value"
  }, displayValue(leftEdge === 'min' ? min : double ? minValue : maxValue)), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__inputs" + (displayTooltip ? ' uk-range-slider__inputs--with-tooltip' : '')
  }, double && /*#__PURE__*/_react.default.createElement("input", {
    type: "range",
    value: minValue,
    min: min,
    max: max,
    step: step,
    onChange: handleMinChange,
    disabled: disabled,
    readOnly: readOnly
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "range",
    value: maxValue,
    min: min,
    max: max,
    step: step,
    onChange: handleMaxChange,
    disabled: disabled,
    readOnly: readOnly
  }), double && /*#__PURE__*/_react.default.createElement("div", {
    className: "value value--min",
    style: {
      left: minPos + "%"
    }
  }, displayValue(minValue)), /*#__PURE__*/_react.default.createElement("div", {
    className: "value value--max",
    style: {
      left: maxPos + "%"
    }
  }, displayValue(maxValue))), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__controls"
  }, double && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__handle",
    style: {
      left: minPos + "%"
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__track"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__track-inner",
    style: {
      left: minPos + "%",
      right: 100 - maxPos + "%"
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__handle",
    style: {
      left: maxPos + "%"
    }
  }))), rightEdge !== 'hide' && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__edge-value uk-range-slider__right-value"
  }, displayValue(rightEdge === 'max' ? max : maxValue)), rightCustomEdge && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__edge-value uk-range-slider__right-value"
  }, rightCustomEdge)), helper.length > 0 && /*#__PURE__*/_react.default.createElement("small", {
    className: "uk-form-item__helper"
  }, helper));
};
RangeSlider.propTypes = {
  /**
   * ID of the RangeSlider (used to bind the label to the Input)
   * NB: the ID will be randomly generated if not set.
   */
  id: _propTypes.default.string,
  /**
   * Name of the RangeSlider (used instead of the ID when submitted)
   */
  name: _propTypes.default.string,
  /**
   * Default value of the RangeSlider
   */
  value: _propTypes.default.any,
  /**
   * Label of the RangeSlider
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  /**
   * Helper text, is replaced by a message in case of error
   */
  helper: _propTypes.default.string,
  /**
   * Minimum value of the RangeSlider
   */
  min: _propTypes.default.number,
  /**
   * Maximun value of the RangeSlider
   */
  max: _propTypes.default.number,
  /**
   * Set the RangeSlider as read-only
   */
  readOnly: _propTypes.default.bool,
  /**
   * Set the RangeSlider as disabled
   */
  disabled: _propTypes.default.bool,
  /**
   * Form-validation: set the RangeSlider as required
   */
  required: _propTypes.default.bool,
  /**
   * Callback function onChange
   * Invoked AFTER new value had been set by the RangeSlider
   */
  onChange: _propTypes.default.func,
  /**
   * Callback function onError
   */
  onError: _propTypes.default.func,
  /**
   * Display current value when hover the thumb
   */
  displayTooltip: _propTypes.default.bool,
  /**
   * Set the currency or number formatting depending on the locale
   * (e.g. 'en', 'en-CA', 'en_CA', etc.)
   */
  locale: _propTypes.default.oneOf(['en', 'fr']),
  /**
   * Display value en currency format.
   */
  displayCurrency: _propTypes.default.bool,
  /**
   * Add suffix after the number.
   */
  displaySuffix: _propTypes.default.string,
  /**
   * Callback function onKeyUp
   */
  onKeyUp: _propTypes.default.func,
  /**
   * Display min value on the left side
   */
  leftEdge: _propTypes.default.oneOf(['min', 'value', 'hide']),
  /**
   * Display custom String on the far left side
   */
  leftCustomEdge: _propTypes.default.string,
  /**
   * Display max value on the right side
   */
  rightEdge: _propTypes.default.oneOf(['max', 'value', 'hide']),
  /**
   * Display custom String on the far left side
   */
  rightCustomEdge: _propTypes.default.string
};
RangeSlider.defaultProps = {
  helper: '',
  readOnly: false,
  disabled: false,
  required: false,
  name: 'single-range',
  min: 0,
  max: 100,
  value: 0,
  displayTooltip: true,
  displayCurrency: false,
  displaySuffix: '',
  leftEdge: 'min',
  rightEdge: 'max',
  leftCustomEdge: undefined,
  rightCustomEdge: undefined,
  locale: 'en'
};
var _default = exports.default = RangeSlider;